import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import Abstract from '../abstract';
import { defineComponent, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createBlock, withCtx, toDisplayString, createCommentVNode, createVNode, createTextVNode } from 'vue';
import Hljs from 'highlight.js/lib/core';
import CopyOutlined from '@ant-design/icons-vue/CopyOutlined';
import CaretRightOutlined from '@ant-design/icons-vue/CaretRightOutlined';
import CheckOutlined from '@ant-design/icons-vue/CheckOutlined';
import { Divider, message } from 'ant-design-vue';
import * as Clipboard from 'clipboard';
import xml from 'highlight.js/lib/languages/xml';
import css from 'highlight.js/lib/languages/css';
import typescript from 'highlight.js/lib/languages/typescript';
import javascript from 'highlight.js/lib/languages/javascript';
import less from 'highlight.js/lib/languages/less';
Hljs.registerLanguage('xml', xml);
Hljs.registerLanguage('css', css);
Hljs.registerLanguage('typescript', typescript);
Hljs.registerLanguage('javascript', javascript);
Hljs.registerLanguage('less', less);
var _sfc_main = defineComponent({
  name: 'CodeSandbox',
  extends: Abstract,
  emits: ['copy'],
  props: {
    code: String,
    title: String,
    describe: String,
    highlightWords: Array,
    theme: {
      type: String,
      default: 'light'
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    alwaysShowCode: {
      type: Boolean,
      default: false
    },
    disableCopy: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CopyOutlined: CopyOutlined,
    CaretRightOutlined: CaretRightOutlined,
    CheckOutlined: CheckOutlined,
    ADivider: Divider
  },
  watch: {
    hideContainer: function hideContainer(val) {
      var container = this.$refs.codeContainer;
      if (val) {
        container.style.height = '0px';
      } else {
        container.style.height = this.height + 'px';
      }
    }
  },
  data: function data() {
    return {
      className: 'code-sandbox',
      showCode: false,
      copied: false,
      height: 0
    };
  },
  computed: {
    formatCode: function formatCode() {
      var _format, _format2, _format3;
      var format = this.code;
      if ((_format = format) !== null && _format !== void 0 && _format.startsWith('\\r\\n')) {
        format = format.replace(/\r\n/, '');
      } else if ((_format2 = format) !== null && _format2 !== void 0 && _format2.startsWith('\\r')) {
        format = format.replace(/\r/, '');
      } else if ((_format3 = format) !== null && _format3 !== void 0 && _format3.startsWith('\n')) {
        format = format.replace(/\n/, '');
      }
      return format;
    },
    hideContainer: function hideContainer() {
      return !this.alwaysShowCode && !this.showCode;
    }
  },
  beforeMount: function beforeMount() {
    var _this$highlightWords,
      _this = this;
    if (((_this$highlightWords = this.highlightWords) === null || _this$highlightWords === void 0 ? void 0 : _this$highlightWords.length) > 0) {
      Hljs.addPlugin({
        'after:highlight': function afterHighlight(result) {
          var regExp = new RegExp("(".concat(_this.highlightWords.join('|'), ")"), 'g');
          result.value = result.value.replace(regExp, '<span class="highlight-words">$1</span>');
        }
      });
    }
  },
  mounted: function mounted() {
    Hljs.configure({
      classPrefix: "hljs-".concat(this.theme, "-")
    });
    Hljs.highlightElement(this.$refs.code);
    this.setContainerHeight();
  },
  methods: {
    setContainerHeight: function setContainerHeight() {
      var codeContainer = this.$refs.codeContainer;
      this.height = codeContainer.offsetHeight;
      if (this.hideContainer) {
        codeContainer.style.height = '0px';
      }
    },
    toggle: function toggle() {
      this.showCode = !this.showCode;
    },
    triggerCopy: function triggerCopy() {
      if (!this.copied) {
        var copyBtn = this.$refs.copyBtn;
        copyBtn.click();
      }
    },
    copy: function copy() {
      var _this2 = this;
      var clipboard = new Clipboard('#copyBtn');
      clipboard.on('success', function () {
        _this2.copied = true;
        if (_this2.showMessage) {
          message.success('复制成功');
        }
        setTimeout(function () {
          _this2.copied = false;
        }, 1000);
        _this2.$emit('copy', _this2.code);
        clipboard.destroy();
      });
    }
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_divider = resolveComponent("a-divider");
  var _component_CaretRightOutlined = resolveComponent("CaretRightOutlined");
  var _component_CopyOutlined = resolveComponent("CopyOutlined");
  var _component_CheckOutlined = resolveComponent("CheckOutlined");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.prefixCls, _ctx.theme])
  }, [createElementVNode("div", null, [renderSlot(_ctx.$slots, "default")]), _ctx.title ? (openBlock(), createBlock(_component_a_divider, {
    key: 0,
    class: normalizeClass("".concat(_ctx.prefixCls, "-title-divider")),
    orientation: "left"
  }, {
    default: withCtx(function () {
      return [createElementVNode("h4", {
        class: normalizeClass("".concat(_ctx.prefixCls, "-title"))
      }, toDisplayString(_ctx.title), 3
      /* TEXT, CLASS */)];
    }),

    _: 1
    /* STABLE */
  }, 8, ["class"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    class: normalizeClass("".concat(_ctx.prefixCls, "-describe"))
  }, [renderSlot(_ctx.$slots, "describe"), !_ctx.$slots.describe && _ctx.describe ? (openBlock(), createElementBlock("div", _hoisted_1, toDisplayString(_ctx.describe), 1
  /* TEXT */)) : createCommentVNode("v-if", true)], 2
  /* CLASS */), _ctx.$slots.default || _ctx.$slots.describe || _ctx.title || _ctx.describe ? (openBlock(), createBlock(_component_a_divider, {
    key: 1,
    class: normalizeClass("".concat(_ctx.prefixCls, "-code-divider")),
    dashed: ""
  }, {
    default: withCtx(function () {
      return [!_ctx.alwaysShowCode ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "trigger",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.toggle && _ctx.toggle.apply(_ctx, arguments);
        })
      }, [createVNode(_component_CaretRightOutlined, {
        class: normalizeClass(["trigger-icon", _ctx.showCode ? "show" : "hide"])
      }, null, 8, ["class"]), createTextVNode(" " + toDisplayString(_ctx.showCode ? "\u9690\u85CF\u4EE3\u7801" : "\u663E\u793A\u4EE3\u7801"), 1
      /* TEXT */)])) : createCommentVNode("v-if", true), !_ctx.disableCopy ? (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(["trigger"]),
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.triggerCopy && _ctx.triggerCopy.apply(_ctx, arguments);
        })
      }, [!_ctx.copied ? (openBlock(), createBlock(_component_CopyOutlined, {
        key: 0
      })) : (openBlock(), createBlock(_component_CheckOutlined, {
        key: 1,
        class: "success"
      })), createTextVNode(" \u590D\u5236\u4EE3\u7801 ")])) : createCommentVNode("v-if", true)];
    }),
    _: 1
    /* STABLE */
  }, 8, ["class"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    ref: "codeContainer",
    class: normalizeClass(["".concat(_ctx.prefixCls, "-container")])
  }, [!_ctx.copied && !_ctx.disableCopy ? (openBlock(), createBlock(_component_CopyOutlined, {
    key: 0,
    class: normalizeClass("".concat(_ctx.prefixCls, "-copy")),
    title: "\u70B9\u51FB\u590D\u5236",
    "data-clipboard-text": _ctx.code,
    onClick: _ctx.copy,
    id: "copyBtn",
    ref: "copyBtn"
  }, null, 8, ["class", "data-clipboard-text", "onClick"])) : !_ctx.disableCopy ? (openBlock(), createBlock(_component_CheckOutlined, {
    key: 1,
    class: normalizeClass("".concat(_ctx.prefixCls, "-copy-success"))
  }, null, 8, ["class"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    class: normalizeClass("".concat(_ctx.prefixCls, "-container-code"))
  }, [createElementVNode("pre", null, [createElementVNode("code", {
    ref: "code",
    class: normalizeClass(["language-html", "hljs-".concat(_ctx.theme), {
      "disable-copy": _ctx.disableCopy
    }]),
    textContent: toDisplayString(_ctx.formatCode)
  }, null, 10, _hoisted_2)])], 2
  /* CLASS */)], 2
  /* CLASS */)], 2
  /* CLASS */);
}

var CodeSandbox = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/code-sandbox/CodeSandbox.js"]]);
export { CodeSandbox as default };